import { isObjectNull } from 'utils/utils';
import { userType } from 'utils/constants'

const serviceName = "/Authorization";
const permissionServiceName = "/Permission";

export function authorizationService(http) {
    return {
        // getRoleMembers : (data) => {
        //     return http.post(serviceName + "/GetUserRolesMember", data)
        // },
        // getRoleAssignPermissions : (data) => {
        //     return http.post(serviceName + "/GetUserRoleAssignedPermission", data)
        // },
        getUserFullAuthorization: (userId) => {
            const paramMessage = {
                userId: userId
            }
            return http.post(serviceName + "/GetFullAuthorization", paramMessage);
        },
        getUserRoleApplicationPermission: (userId, applicationId) => {
            // var data = {params: {"userId": userId, "applicationId": applicationId}};
            const dataParam = {
                userId: userId,
                applicationId: applicationId
            }
            return http.post(serviceName + "/GetUserRoleApplicationPermission", dataParam)
        },
        getUserRoleMember: (userId, roleId) => {
            var parameters = {
                userId: userId,
                roleId: roleId
            }
            return http.post(serviceName + "/GetUserRoleMember", parameters)
        },
        getPersonnelRoles: (userId) => {
            var parameters = {
                userId: userId
            }
            return http.post(serviceName + "/GetPersonnelRoles", parameters)
        },
        getDisciplineHeadSection: (disciplineId) => {
            var parameters = {
                disciplineId: disciplineId
            }
            return http.post(serviceName + "/GetDisciplineHeadSection", parameters)
        },
        getUserAssignedPermissions: (applicationId) => {
            var parameters = {
                applicationId
            }
            return http.post(serviceName + "/GetUserAssignedPermissions", parameters);
        },
        getUserLevel: (userId) => {
            var parameter = {
                UserId: userId
            };

            return http.post(serviceName + "/GetUserLevelAsync",parameter);
        },
        isUserSystemAdministrator: userId => {
            var parameter = {
                UserId: userId
            };
            return http.post(serviceName + "/IsUserSystemAdministrator",parameter);

        },
        isUserSubSystemAdministrator:  (userId, applicationAdministrationId) => {
            const dataParam = {
                userId,
                applicationAdministrationId
            }
            return http.post(serviceName + "/IsUserSubSystemAdministrator", dataParam)
        },
        getRolePermissions: roleIds => {
            let roleItems = [];
            roleIds.map(item => {
                roleItems = [...roleItems, {
                    Id: item
                }];
            })
            return http.post(permissionServiceName + "/GetRolePermissions",  roleItems);
        },
        getApplicationPermission: (userId, applicationId, applicationComponentId) => {
            let params = {
                userId,
                applicationId,
                applicationComponentId
            };

            return http.post(`${serviceName}/GetApplicationPermission`, params);
        },
       
    }
}